import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Divider from '../../atoms/Divider';
import Text from '../../atoms/Text';
import TabsList from '../TabsList';

import styles from './MyAccountHeader.module.scss';
import usePresenter from './MyAccountHeader.presenter';
import getProps from './MyAccountHeader.props';
import { MyAccountHeaderCombinedProps } from './types';


const MyAccountHeader: React.FC<MyAccountHeaderCombinedProps> = (props) => {
  const {
    className,
    classes,
    text,
    button,
    tabsList,
    divider,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.myAccountHeader;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.content, classes?.content)}>
        <div className={cx(styles.topContent, classes?.topContent)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button}/>
        </div>
        <TabsList
          className={cx(styles.tabsList, classes?.tabsList)}
          {...internalProps.tabsList}
          {...tabsList}/>
      </div>
      <Divider
        className={cx(styles.divider, classes?.divider)}
        {...internalProps.divider}
        {...divider}/>
    </div>
  );
};

export default MyAccountHeader;

